import { FuelTypography } from '@frete.com/fuel-react';
import { FuelDialog } from '@frete.com/fuel-station-react';
import actions from 'constants/reducers';
import { useAppContext } from 'hooks/useAppContext';
import { usePayPerUseExtraTruckers } from 'hooks/usePayPerUseExtraTruckers';
import { usePurchaseExtraSuggestedTruckers } from 'hooks/usePurchaseExtraSuggestedTruckers';
import { useUnlockSuggestedTruckersEvents } from 'hooks/useUnlockSuggestedTruckersEvents';
import React, { FC } from 'react';
import { brlCurrencyFormatter } from 'utils/brlCurrencyFormatter';

const ModalPurchaseExtraSuggestedTruckers: FC = () => {
  const {
    state: {
      suggestedTruckersExtension: { isFetching },
      modals: { isOpenPurchaseExtraSuggestedTruckers },
    },
    dispatch,
  } = useAppContext();

  const { price, lockedTruckersAmount, freeAvailable } = usePayPerUseExtraTruckers();
  const { fetchPurchaseExtraSuggestedTruckers } = usePurchaseExtraSuggestedTruckers();
  const { sendUnlockSuggestedTruckersEvent } = useUnlockSuggestedTruckersEvents();

  const handleClose = () => {
    sendUnlockSuggestedTruckersEvent('cancel');
    dispatch({ type: actions.modals.setClosePurchaseExtraSuggestedTruckers });
  };

  const handleConfirm = () => {
    const consumptionType = freeAvailable > 0 ? 'free' : 'paid';

    sendUnlockSuggestedTruckersEvent('button-confirm', consumptionType);
    fetchPurchaseExtraSuggestedTruckers();
  };

  const getDescription = () => {
    if (freeAvailable > 0) {
      const remaining = freeAvailable - 1;
      const availableText = remaining === 1 ? 'disponível' : 'disponíveis';
      return `Você consumirá 01 desbloqueio de motoristas da sua degustação, restando ${remaining} ${availableText}.`;
    }

    return `O valor desse desbloqueio é de ${brlCurrencyFormatter(
      price
    )} e será cobrado na sua próxima fatura de extras.`;
  };

  return (
    <FuelDialog.Root
      isOpen={isOpenPurchaseExtraSuggestedTruckers}
      onClose={handleClose}
      portalName="portal-trucker-listing"
      removePortalOnDestroy={false}
      width="md"
    >
      <FuelDialog.Header>
        <FuelTypography size="heading-sm" weight="bold" color="neutral-strong">
          {`Desbloquear ${lockedTruckersAmount} motoristas dessa lista`}
        </FuelTypography>
      </FuelDialog.Header>
      <FuelDialog.Body>
        <FuelTypography color="neutral-default" weight="medium" size="body-md">
          {getDescription()}
        </FuelTypography>
      </FuelDialog.Body>
      <FuelDialog.Footer>
        <FuelDialog.Action variant="primary" size="large" onClick={handleConfirm} isLoading={isFetching}>
          Continuar
        </FuelDialog.Action>
        <FuelDialog.Action variant="tertiary" size="large" onClick={handleClose}>
          Cancelar
        </FuelDialog.Action>
      </FuelDialog.Footer>
    </FuelDialog.Root>
  );
};

export default ModalPurchaseExtraSuggestedTruckers;
